import {
   rand,
   randNumber,
   randProductAdjective,
   randBoolean,
} from '@ngneat/falso';

import { ShipmentTypes, ShipmentModes } from '@library/common/models';

import { ModulesRoutes } from './modules/modules-routes.mock';

import { titleCase } from '@library/common/functions';
import { MockCountries } from '@library/common/models/mock';

const Countries = MockCountries({
   includePorts: true, includeRegions: true, includePostalDetails: true,
});

export const LibraryRoutes = [
   ...ModulesRoutes,

   { path: 'enum/currencies', verb: 'GET', collection: () => [ 'USD', 'CAD' ]},
   { path: 'enum/countries', verb: 'GET', collection: () => Countries },
   { path: 'enum/ocean_ports', verb: 'GET', collection: () =>
      Countries.filter( c => c.ports ).map( c => ({ code: c.code, country: c.country, ports: c?.ports }))
   },
   { path: 'enum/servicelevels', verb: 'GET', collection: () => Array.from({ length: randNumber() }, _ => ({
      name: randProductAdjective(),
      shipType: rand( ShipmentTypes.slice() ),
      mode: rand( ShipmentModes.slice() ),
      book: randBoolean(),
   }))},
   { path: 'enum', verb: 'GET', collection: () =>
      Array.from({
         length: randNumber({ min: 1, max: 10 })
      }, _ => titleCase( randProductAdjective() ) as string )
   },
];
